export * from '@/views/HomeView/HomeContentBaseSlider/HomeContentBaseSlider';
